var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5839CB;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M44,33h-.5v-.486A.51.51,0,0,0,43.024,32a.5.5,0,0,0-.524.5V33h-7v-.486A.51.51,0,0,0,35.024,32a.5.5,0,0,0-.524.5V33H34a2,2,0,0,0-2,2v9a2,2,0,0,0,2,2H44a2,2,0,0,0,2-2V35A2,2,0,0,0,44,33ZM35.25,44a.75.75,0,1,1,.75-.75A.75.75,0,0,1,35.25,44Zm0-2.5a.75.75,0,1,1,.75-.75A.75.75,0,0,1,35.25,41.5Zm2.5,2.5a.75.75,0,1,1,.75-.75A.75.75,0,0,1,37.75,44Zm0-2.5a.75.75,0,1,1,.75-.75A.75.75,0,0,1,37.75,41.5Zm2.5,2.5a.75.75,0,1,1,.75-.75A.75.75,0,0,1,40.25,44Zm0-2.5a.75.75,0,1,1,.75-.75A.75.75,0,0,1,40.25,41.5Zm0-2.5a.75.75,0,1,1,.75-.75A.75.75,0,0,1,40.25,39Zm2.5,2.5a.75.75,0,1,1,.75-.75A.75.75,0,0,1,42.75,41.5Zm0-2.5a.75.75,0,1,1,.75-.75A.75.75,0,0,1,42.75,39ZM45,35.251v.5a.25.25,0,0,1-.25.25H33.25a.25.25,0,0,1-.25-.25V35a1,1,0,0,1,1-1H44a1,1,0,0,1,1,1Z",
    transform: "translate(-32 -32.001)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPrimary);
export default __webpack_public_path__ + "static/media/calendar-primary.026a80c578f1892e089e015ac8f30e0b.svg";
export { ForwardRef as ReactComponent };